import axiosUtil from "../utils/axiosUtil"
import moment from "moment";

const tripsApi = {
    getTripsWithin30Days: async ({ perPage, page }) => {
        const toDate = moment().format('YYYY-MM-DD');
        const fromDate = moment().subtract(30, 'days').format('YYYY-MM-DD')
        try {
            const result = await axiosUtil.get('/trips', {
                perPage: (!perPage || perPage <= 0) ? 10 : perPage,
                page: (!page || page <= 0) ? 1 : page,
                fromDate,
                toDate
            })
            return result;
        } catch (error) {
            console.error(error);
        }
    },
    getTripById: async (tripId) => {
        try {
            const result = await axiosUtil.get(`/trips/${tripId}`)
            return result;
        } catch (error) {
            console.error(error);
        }
    }
}

export default tripsApi;
